<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import "./styles/style.less";

export default {
  name: "App",
};
</script>
<style lang="less" scoped>
#app {
  height: 100%;
}

/deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 12px !important;
  height: 4px;
  border-radius: 4px;
  overflow-y: scroll;
}
</style>
